import React,{lazy} from 'react'
import {
  BrowserRouter as Router,
  
  Route,
  Routes,
  
} from "react-router-dom";
import HomePage from './pages/Home';
// import Book from './pages/Book';
// import CodingAlert from './pages/CodingAlert';
// import PaperPreviousYear from './pages/Paper';
// import Notification from './pages/Notification';
import DataProvider from './context/db.context';
import withLazy from './components/withLazy';

const Book = withLazy(lazy(()=>import("./pages/Book")))
const CodingAlert = withLazy(lazy(()=>import("./pages/CodingAlert")))
const PaperPreviousYear = withLazy(lazy(()=>import("./pages/Paper")))
const Notification = withLazy(lazy(()=>import("./pages/Notification")))


export default function App() {
  
  return (
    <Router>
     <DataProvider>
     <Routes>
     <Route exact path="/" element={<HomePage/>}/> 
     <Route exact path="/Book" element={<Book/>}/> 
     <Route exact path="/CodingAlert" element={<CodingAlert/>}/> 
     <Route exact path="/Paper" element={<PaperPreviousYear/>}/> 
     <Route exact path="/Notification" element={<Notification/>}/> 
     </Routes>
    </DataProvider> 
    </Router>
  )
}
